<template>
    <Card :ref="e => (refs.form = e)" layout="horizontal">
        <TemplateBuilder :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        <CTable
            :isLoading="isLoading"
            v-model:columns="data.columns"
            v-model:page="data.page"
            :options="data.tableOptions"
            :rowClassName = "rowClassName"
            :visibleSearch="false"
        ></CTable>
    </Card>
</template>

<script>
import { Card } from "ant-design-vue";
import { defineAsyncComponent, defineComponent, reactive } from "vue";
import { initForm, isLoading, /*onClickModalOk*/ } from "./process.logic";

export default defineComponent({
    components: {
        Card,
        CTable: defineAsyncComponent(() => import("../../../../../components/table/CTable")),
        TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder"))
    },
    props: {
        viewOnly: { default: false },
        form: {},
        dataProp: {},
        itemsKey: {},
        rowClassName: { default: () => record => (record.refSubStanceProcess === null ? "text-danger" : "") },
    },
    setup(props) {
        const data = reactive({ ...props.dataProp });
        const refs = reactive({ form: null });
        initForm({ props, data, refs });
        return { props, data, refs, isLoading };
    }
});
</script>
